import { apiGet, apiPost } from './apiClient';
import {
  AvailableClass,
  PendingEnrollmentResponse,
} from '../types/PendingEnrollment.type';

type ApiEnvelope<T> = { status: number; message: string; data: T };

export const getPendingEnrollments = async (params: {
  serviceType: string;
  package: string;
  search: string;
  registrationDateFrom: string;
  registrationDateTo: string;
  page: number;
  limit: number;
}) => {
  const query = new URLSearchParams({
    serviceType: params.serviceType,
    package: params.package,
    search: params.search,
    registrationDateFrom: params.registrationDateFrom,
    registrationDateTo: params.registrationDateTo,
    page: String(params.page),
    limit: String(params.limit),
  });
  return apiGet<PendingEnrollmentResponse>(
    `/class/pending-enrollments?${query.toString()}`,
  );
};

export const getAvailableClasses = async (registrationId: number) => {
  const response = await apiGet<ApiEnvelope<AvailableClass[]>>(
    `/class/pending-enrollments/${registrationId}/available-classes`,
  );
  return response.data;
};

export const addPendingEnrollment = async (
  registrationId: number,
  classId: number,
) =>
  apiPost<ApiEnvelope<unknown>, { classId: number }>(
    `/class/pending-enrollments/${registrationId}/add`,
    { classId },
  );
